import { useCallback } from 'react';
/**
 * Returns an `onScroll` event handler that will fire the supplied {@link callback} whenever the user is near the bottom
 * of the scrollable area.
 */ export function useOnScrollNearBottom(/**
   * How far from the bottom (in pixels) should we trigger the supplied callback?
   */ activationDistance, /**
   * The callback that we'll fire when .
   *
   * This function will be provided `scrollTop` and `distanceToBottom` for convenience.
   */ callback) {
    return useCallback((scrollTop, distanceToBottom)=>{
        if (scrollTop !== 0 && distanceToBottom <= activationDistance) {
            callback(scrollTop, distanceToBottom);
        }
    }, [
        callback,
        activationDistance
    ]);
}

//# sourceMappingURL=useOnScrollNearBottom.js.map